import { Stack, styled } from '@mui/material';

const StyledClientProfileHeaderDetails = styled(Stack)(() => ({
  alignItems: 'center'
}));

export default StyledClientProfileHeaderDetails;
